import { useState } from "react";
import { Button, SearchSelect, SearchSelectItem, TextInput } from "@tremor/react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { EISAGGELIES } from "../../features/poinika/eisaggelies";
import {
  acceptedABMChars,
  removeDiacriticsAndCapitalize,
} from "../../utils/checkMisthosi";

const NOTE_MAX = 50;

const hasInvalidChars = (abm) => [...abm].some((ch) => !acceptedABMChars.includes(ch));

// Desktop version of the inline form in Poiniko.jsx (same payload).
const AddPoinikoForm = ({ onClose, onAdded }) => {
  const axiosPrivate = useAxiosPrivate();
  const [abm, setAbm] = useState("");
  const [eisag, setEisag] = useState("");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const abmError = abm && hasInvalidChars(abm) ? "Μη αποδεκτοί χαρακτήρες" : "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!abm || abmError || !eisag || saving) return;
    setSaving(true);
    setErrMsg("");
    try {
      await axiosPrivate.post("/poinpin", JSON.stringify({ abm, eisag, note }), {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });
      onAdded(null);
      onClose();
    } catch (err) {
      console.error(err);
      setErrMsg(err?.response?.data?.message || "Αποτυχία καταχώρησης. Δοκιμάστε ξανά.");
      setSaving(false);
    }
  };

  return (
    <form className="ds-form" onSubmit={handleSubmit}>
      <div className="ds-modal-header">
        <h2>Νέο ΑΒΜ</h2>
        <button type="button" className="ds-link-btn" onClick={() => onClose()}>
          Κλείσιμο
        </button>
      </div>
      {errMsg && (
        <p className="ds-form-error" role="alert">
          {errMsg}
        </p>
      )}
      <label className="ds-form-field">
        <span>ΑΒΜ</span>
        <TextInput
          autoFocus
          placeholder="ΑΒΜ"
          value={abm}
          onValueChange={(v) => setAbm(removeDiacriticsAndCapitalize(v))}
          error={Boolean(abmError)}
          errorMessage={abmError}
        />
      </label>
      <div className="ds-form-field">
        <span>Εισαγγελία</span>
        <SearchSelect value={eisag} onValueChange={setEisag} placeholder="Εισαγγελία">
          {EISAGGELIES.map((e) => (
            <SearchSelectItem key={e.value} value={e.value}>
              {e.label}
            </SearchSelectItem>
          ))}
        </SearchSelect>
      </div>
      <label className="ds-form-field">
        <span>Σημείωση</span>
        <TextInput
          placeholder={`Σημείωση μέχρι ${NOTE_MAX} χαρακτήρες`}
          value={note}
          onValueChange={(v) => setNote(v.slice(0, NOTE_MAX))}
        />
      </label>
      <div className="ds-form-actions">
        <Button
          type="submit"
          color="emerald"
          loading={saving}
          disabled={!abm || Boolean(abmError) || !eisag}
        >
          Προσθήκη
        </Button>
      </div>
    </form>
  );
};

export default AddPoinikoForm;
